import { Link } from "@tanstack/react-router";
import { Lock, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

export function UpgradeOverlay({
  feature,
  description,
  requiredPlan = "Trung tâm",
  priceHint = "Từ 199.000đ/tháng",
}: {
  feature: string;
  description: string;
  requiredPlan?: string;
  priceHint?: string;
}) {
  return (
    <div className="rounded-3xl border-2 border-dashed border-blue-200/60 bg-gradient-to-b from-blue-50/40 to-white p-10 md:p-14 text-center">
      <div className="size-14 rounded-2xl bg-blue-50 dark:bg-blue-500/10 grid place-items-center mx-auto mb-5 ring-1 ring-blue-100">
        <Lock className="size-6 text-blue-500" strokeWidth={1.5} />
      </div>
      <h3 className="font-display text-2xl font-bold text-slate-900 dark:text-white">{feature}</h3>
      <p className="text-slate-500 dark:text-slate-400 mt-3 max-w-md mx-auto leading-relaxed">{description}</p>
      <Link to="/billing">
        <Button
          className="mt-7 h-11 px-6 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:opacity-90 active:scale-[0.98] transition-all duration-500 gap-1.5 shadow-[0_8px_30px_rgb(37,99,235,0.25)]"
        >
          <Zap className="size-4" strokeWidth={1.5} />
          Nâng cấp gói {requiredPlan}
        </Button>
      </Link>
      <p className="text-xs text-slate-400 dark:text-slate-500 mt-4">{priceHint}</p>
    </div>
  );
}
